export class AnniversaryClubWidgetSettings {
  public sendingTime: Date;

  public stopSendingYear?: Date;
  public anniversaryClubUrl: string;
}
